import Navbar from './Navbar';
import Home from './Home';
import Footer  from './Footer';
import Details from './Details';
import Search from './Search';
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from 'react-router-dom';
import React from 'react';
import {connect} from 'react-redux';
import { handleBollywoodMovies, handleActionMovies, handleTrendingMovie ,handleComedyMovies,handleHorrorMovies,handleHollywoodMovies } from '../actions/index'

class App extends React.Component {
   componentDidMount(){
    const { store } = this.props; 
    this.props.store.dispatch(handleBollywoodMovies());
    this.props.store.dispatch(handleActionMovies());
    this.props.store.dispatch(handleComedyMovies());
    this.props.store.dispatch(handleHollywoodMovies());
    this.props.store.dispatch(handleHorrorMovies());
    this.props.store.dispatch(handleTrendingMovie());
   }
  render(){

  const {dispatch} = this.props.store;
  const { xDetails, xHome, xSearch} = this.props.store.getState();

  const {searchResult} =xSearch;
  console.log('Search',searchResult);
  const {more} = xDetails;

  return (
    <Router>
    <Switch>
    <div className="App">
    
    <Navbar {...this.props} dispatch={dispatch}/>
    <div className="body">
   
      
        <Route exact path="/" render={(props) => {
          return <Home {...props} dispatch={dispatch} home={xHome} />
        }}/>
        <Route path="/movie-details" render={(props) => {
          return <Details {...props} dispatch={dispatch} details={xDetails} />
        //   :(<Redirect
        //     to={{
        //       pathname: '/',
        //       state: {
        //         from: props.location,
        //       },
        //     }}
        //   />)
        }}/>
        <Route path="/search" render={(props) => {
          return <Search {...props} dispatch={dispatch} search={xSearch} />
        }}/>
      
   
    </div>
  
      <Footer/>
  
    </div>
    </Switch>

    </Router>
  );
}
}

function mapStateToProps(state) {
  return {
    props:state
  };
}

export default connect(
  mapStateToProps,
)(App)
